/** Copyright (c) 2020 T.Rowe Price. All rights reserved. */
import { getExternalInvestmentsBalances } from './ExternalInvestmentsBalancesSelectors';
import { createSelector } from 'reselect';

export const getShowConsentModal = (state) =>
  state.externalInvestmentConsent.showConsentModal;
export const getShowLinkModal = (state) =>
  state.externalInvestmentConsent.showLinkModal;
export const getExternalInvestmentConsentStatus = (state) =>
  state.externalInvestmentConsent.status;
export const getExternalInvestmentConsent = (state) =>
  state.externalInvestmentConsent.consent;
export const getDelayedLinkAccount = (state) =>
  state.externalInvestmentConsent.delayLinkAccount;

export const getExternalInvestmentError = createSelector(
  getExternalInvestmentsBalances,
  (balances) => {
    if (!balances) {
      return {};
    }
    const balanceDetails = balances.find(({ details }) => {
      const { errorMessage, allExternalAccountsInGroupError } = details;
      return allExternalAccountsInGroupError || errorMessage;
    });
    if (balanceDetails) {
      const {
        details: { errorMessage }
      } = balanceDetails;
      return errorMessage;
    }
  }
);
